import React from "react";
import Html from "./Html";

const _403Error = () => {
    return (
        <Html/>
    );
}

export default _403Error;